module.exports = __webpack_public_path__ + "1ff3e5039c6ac7f4c80cb62087e14be7.png";